var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.066,
    height: 29.066,
    viewBox: "0 0 29.066 29.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M14.533,16.349A8.175,8.175,0,1,0,6.358,8.175,8.177,8.177,0,0,0,14.533,16.349ZM21.8,18.166H18.671a9.882,9.882,0,0,1-8.277,0H7.266A7.266,7.266,0,0,0,0,25.432v.908a2.726,2.726,0,0,0,2.725,2.725H26.341a2.726,2.726,0,0,0,2.725-2.725v-.908A7.266,7.266,0,0,0,21.8,18.166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAlt);
export default __webpack_public_path__ + "static/media/user-alt.ef4c8de05b0ebc1a51cc14873ffec075.svg";
export { ForwardRef as ReactComponent };